module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><path d=\"M16.5 3.5h-13a2.15 2.15 0 0 0-2 2v9a2.15 2.15 0 0 0 2 2h13a2.15 2.15 0 0 0 2-2v-9a2.15 2.15 0 0 0-2-2zm-.908 4.617L11.05 11.36a1.808 1.808 0 0 1-2.1 0L4.407 8.117A1 1 0 1 1 5.57 6.49L10 9.654l4.43-3.165a1 1 0 0 1 1.162 1.628z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/mail.svg
// module id = 244
// module chunks = 1